import { useCallback, useEffect, useRef, useState } from 'react';
import { useSocket } from '../../../components/contexts/SocketContext';
import { useAuth } from '../../../components/contexts/AuthContext';
import { errorText } from '../models/attendance';
export function useAttendanceRead(load, { live = false } = {}) {
  const { socket } = useSocket(), { authState } = useAuth();
  const [data, setData] = useState(null), [loading, setLoading] = useState(true), [error, setError] = useState(null), revision = useRef(0);
  const identity = `${authState?.id}:${authState?.token}:${authState?.session_id}`;
  const reload = useCallback(async ({ background = false } = {}) => {
    const request = ++revision.current; if (!background) setLoading(true);
    try { const result = await load(); if (request === revision.current) { setData(result); setError(null); } }
    catch (failure) { if (request === revision.current) setError(errorText(failure)); }
    finally { if (request === revision.current) setLoading(false); }
  }, [load]);
  useEffect(() => { const requests = revision; setData(null); reload(); return () => { requests.current++; }; }, [reload, identity]);
  useEffect(() => {
    if (!socket || !live) return undefined;
    const change = event => {
      // Hints contain only state/since. Apply those fields, then reload the full resource.
      if (event?.user_id) setData(current => Array.isArray(current) ? current.map(row => Number(row.user_id) === Number(event.user_id) ? { ...row, state: event.state, since: event.since, time_in_state_seconds: undefined } : row) : current);
      reload({ background: true });
    };
    const reconcile = () => reload({ background: true });
    socket.on('connect', reconcile); socket.on('attendance:state_changed', change); socket.on('attendance:settings_changed', reconcile);
    return () => { socket.off('connect', reconcile); socket.off('attendance:state_changed', change); socket.off('attendance:settings_changed', reconcile); };
  }, [socket, live, reload]);
  return { data, loading, error, reload };
}
